import { render, staticRenderFns } from "./VaCheckbox.vue?vue&type=template&id=5b97bbca&"
import script from "./VaCheckbox.vue?vue&type=script&lang=js&"
export * from "./VaCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VaCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports